import * as React from "react";
import { useNavigate } from 'react-router-dom';
import { createInvoice } from "../service/weexpertService";
import { toast } from "@/components/ui/use-toast";
import { useTranslation } from "react-i18next";
import { InvoiceForm, MODE } from "@/components/forms/invoice";

const InvoiceCreatePage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleSave = (invoiceData) => {
    const {
      client,
      invoiceType,
      issueDate,
      domainDate,
      status,
      counterpartyName,
      counterpartyOrigin,
      counterpartyNip,
      counterpartyEmail,
      counterpartyType,
      counterpartyAddress,
      counterpartyPostIndex,
      counterpartyCity,
      counterpartyCountry,
      typeOfPayment,
      wayOfPayment,
      paymentStatus,
      paymentDueDate,
      paymentCurrency,
      paymentCurrencyRate,
      paymentCurrencyRateDate,
      paymentIban,
      internalComment,
      externalComment,
      rows,
      invoiceBrutto,
      invoiceTotalNetto,
      invoiceVAT,
      useDifferentRecipient,
      recipientCounterparty,
      paymentSwift
    } = invoiceData;

    return createInvoice(
      invoiceType,
      domainDate,
      status,
      counterpartyName,
      counterpartyType,
      counterpartyOrigin,
      counterpartyName,
      counterpartyPostIndex,
      counterpartyNip,
      counterpartyCity,
      counterpartyEmail,
      counterpartyCountry,
      counterpartyAddress,
      typeOfPayment,
      wayOfPayment,
      paymentStatus,
      paymentDueDate,
      paymentCurrency,
      paymentCurrencyRate,
      paymentIban,
      invoiceTotalNetto,
      invoiceBrutto,
      invoiceVAT,
      client.id,
      rows,
      internalComment,
      externalComment,
      paymentCurrencyRateDate,
      issueDate,
      useDifferentRecipient,
      {
        counterpartyType: recipientCounterparty.counterpartyType,
        name: recipientCounterparty.counterpartyName,
        address: recipientCounterparty.counterpartyAddress,
        postIndex: recipientCounterparty.counterpartyPostIndex,
        city: recipientCounterparty.counterpartyCity,
        email: recipientCounterparty.counterpartyEmail,
        country: recipientCounterparty.counterpartyCountry,
        NIP: recipientCounterparty.counterpartyNip,
        origin: recipientCounterparty.counterpartyOrigin
      },
      paymentSwift
    )
      .then((response) => {
        if (response.status === 200) {
          toast({
            title: t("alerts:toast_succes_invoice_create_title"),
            description: t("alerts:toast_succes_invoice_create_description"),
          });
          navigate('/admin/invoices/sales');
        }
      })
      .catch((error) => {
        toast({
          title: t("alerts:toast_error_invoice_title"),
          description: t("alerts:toast_error_invoice_description"),
          variant: "destructive"
        });
        console.error(error);
      });
  };

  return (
    <div className="relative bg-grayLightMainBg px-8">
      <InvoiceForm mode={MODE.CREATE} onSave={handleSave} />
    </div>
  );
};

export default InvoiceCreatePage;
